import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert, successAlert } from "../Alerts/actions";
import {
  addClockFailure,
  addClockSuccess,
  approveDropFailure,
  approveDropSuccess,
  approveSwapFailure,
  approveSwapSuccess,
  clockinFailure,
  clockinSuccess,
  copyRosterFailure,
  copyRosterSuccess,
  getPaidHoursFailure,
  getPaidHoursSuccess,
  getSettingsFailure,
  getSettingsHistoryFailure,
  getSettingsHistorySuccess,
  getSettingsSuccess,
  rejectDropFailure,
  rejectDropSuccess,
  rejectSwapFailure,
  rejectSwapSuccess,
  saveSettingsFailure,
  saveSettingsSuccess,
  updateClockinFailure,
  updateClockinSuccess,
  updateRequestFailure,
  updateRequestSuccess,
  claimShiftSuccess,
  claimShiftFailure,
  getLocSettingsSuccess,
  getLocSettingsFailure,
  saveLocSettingsSuccess,
  saveLocSettingsFailure,
} from "./actions";
import {
  APPROVE_DROP,
  APPROVE_SWAP,
  CLOCK_IN,
  COPY_ROSTER,
  GET_SETTINGS,
  REJECT_DROP,
  REJECT_SWAP,
  SAVE_SETTINGS,
  UPDATE_CLOCKIN,
  UPDATE_REQUEST,
  ADD_CLOCK,
  GET_PAID_HOURS,
  GET_SETTINGS_HISTORY,
  CLAIM_SHIFT,
  GET_LOC_SETTINGS,
  SAVE_LOC_SETTINGS,
} from "./constants";

export function* fetchSettingsSaga({ payload, onGetSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/company-setting/${payload}`,
    );
    typeof onGetSuccess === "function" && onGetSuccess(data);
    yield put(getSettingsSuccess(data));
  } catch (e) {
    typeof onGetSuccess === "function" && onGetSuccess(null);
    yield put(getSettingsFailure());
    // if (typeof e === "string") yield put(errorAlert(e));
    // else if (typeof e.error === "string") yield put(errorAlert(e.error));
    // else if (e.message !== undefined)
    //   yield put(errorAlert("Error while fetching!"));
  }
}
export function* saveSettingsSaga({ payload, onSave }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).post,
      `/api/company-setting/add`,
      payload.data,
    );
    yield put(saveSettingsSuccess());
    // yield put(getSettings(payload.data.company_id));
    typeof onSave === "function" && onSave(payload.data.company_id);
  } catch (e) {
    yield put(saveSettingsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while saving"));
  }
}

export function* clockinSaga({ payload, onClockSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).post,
      `/api/clock-in-by-manager`,
      payload.data,
    );
    yield put(clockinSuccess());
    yield put(successAlert("Clockin added successfully!"));
    typeof onClockSuccess === "function" && onClockSuccess(data);
  } catch (e) {
    yield put(clockinFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while clocking"));
  }
}

export function* updateClockinSaga({ payload, onUpdateSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).post,
      `/api/clock-in/edit/${payload.clockin_id}`,
      payload.data,
    );
    typeof onUpdateSuccess === "function" && onUpdateSuccess();
    yield put(updateClockinSuccess());
    yield put(successAlert("Clockin details updated successfully!"));
  } catch (e) {
    yield put(updateClockinFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while updating"));
  }
}

export function* approveDropSaga({ payload, onApproveDrop }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).post,
      `/api/drop-shift-approved/${payload.employee_id}`,
      payload.data,
    );
    yield put(approveDropSuccess());
    yield put(successAlert("Drop approved successfully"));
    typeof onApproveDrop === "function" && onApproveDrop();
  } catch (e) {
    yield put(approveDropFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while updating"));
  }
}

export function* rejectDropSaga({ payload, onRejectDrop }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).post,
      `/api/drop-shift-reject/${payload.employee_id}`,
      payload.data,
    );
    yield put(rejectDropSuccess());
    yield put(successAlert("Drop rejected successfully"));
    typeof onRejectDrop === "function" && onRejectDrop();
  } catch (e) {
    yield put(rejectDropFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while updating"));
  }
}

export function* updateRequestSaga({ payload, onUpdateRequest }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).post,
      `/api/app/swap-shift-accept/${payload.swap_id}`,
      payload.data,
    );
    yield put(updateRequestSuccess());
    yield put(successAlert("Request updated successfully!"));
    typeof onUpdateRequest === "function" && onUpdateRequest(data);
  } catch (e) {
    yield put(updateRequestFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while updating"));
  }
}

export function* approveSwapSaga({ payload, onApproveSwap }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).post,
      `/api/app/swap-shift-approved`,
      payload.data,
    );
    yield put(approveSwapSuccess());
    yield put(successAlert("Request updated successfully!"));
    typeof onApproveSwap === "function" && onApproveSwap();
  } catch (e) {
    yield put(approveSwapFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while updating"));
  }
}

export function* rejectSwapSaga({ payload, onRejectSwap }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).post,
      `/api/app/swap-shift-reject`,
      payload.data,
    );
    yield put(rejectSwapSuccess());
    yield put(successAlert("Request updated successfully!"));
    typeof onRejectSwap === "function" && onRejectSwap();
  } catch (e) {
    yield put(rejectSwapFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while updating"));
  }
}

export function* copyRosterSaga({ payload, onCopy }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).post,
      `/api/copy-paste-shift`,
      payload.data,
    );
    yield put(copyRosterSuccess());
    yield put(successAlert("Rota copied successfully!"));
    typeof onCopy === "function" && onCopy();
  } catch (e) {
    yield put(copyRosterFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while copying"));
  }
}

export function* addClockSaga({ payload, onAdd }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).post,
      `/api/manual-clock-in-out`,
      payload,
    );
    yield put(addClockSuccess());
    typeof onAdd === "function" && onAdd();
    yield put(successAlert("Clock in added successfully!"));
  } catch (e) {
    yield put(addClockFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while adding"));
  }
}

export function* getPaidHoursSaga({ payload, onGet }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).post,
      `/api/get-paid-hours`,
      payload,
    );
    yield put(getPaidHoursSuccess(data));
    typeof onGet === "function" && onGet(data);
  } catch (e) {
    yield put(getPaidHoursFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while getting paid hours"));
  }
}

export function* getSettingsHistorySaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/company-setting-history/${payload.id}`,
    );

    if (data) {
      yield put(getSettingsHistorySuccess(data));
    }
  } catch (e) {
    yield put(getSettingsHistoryFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* claimShiftSaga({ payload, onClaim }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).post,
      `/api/claim-shift-request`,
      payload,
    );
    yield put(claimShiftSuccess());
    yield put(successAlert("Open shift claimed successfully!"));
    typeof onClaim === "function" && onClaim();
  } catch (e) {
    yield put(claimShiftFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while claiming shift"));
  }
}
export function* getLocSettingsSaga({ payload, onGet }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/location-setting/${payload}`,
    );
    typeof onGet === "function" && onGet(data ?? {});
    yield put(getLocSettingsSuccess(data));
  } catch (e) {
    typeof onGet === "function" && onGet([]);
    yield put(getLocSettingsFailure());
  }
}

export function* saveLocSettingsSaga({ payload, onSave }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).post,
      `/api/location-setting/add`,
      payload,
    );
    yield put(saveLocSettingsSuccess());
    yield put(successAlert("Location settings saved successfully!"));
    typeof onSave === "function" && onSave();
  } catch (e) {
    yield put(saveLocSettingsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while saving"));
  }
}

export function* fetchSettingsFlow() {
  yield takeEvery(GET_SETTINGS, fetchSettingsSaga);
}
export function* saveSettingsFlow() {
  yield takeEvery(SAVE_SETTINGS, saveSettingsSaga);
}
export function* clockinFlow() {
  yield takeEvery(CLOCK_IN, clockinSaga);
}
export function* updateClockinFlow() {
  yield takeEvery(UPDATE_CLOCKIN, updateClockinSaga);
}
export function* approveDropFlow() {
  yield takeEvery(APPROVE_DROP, approveDropSaga);
}
export function* updateRequestFlow() {
  yield takeEvery(UPDATE_REQUEST, updateRequestSaga);
}
export function* approveSwapFlow() {
  yield takeEvery(APPROVE_SWAP, approveSwapSaga);
}
export function* rejectDropFlow() {
  yield takeEvery(REJECT_DROP, rejectDropSaga);
}
export function* rejectSwapFlow() {
  yield takeEvery(REJECT_SWAP, rejectSwapSaga);
}
export function* copyRosterFlow() {
  yield takeEvery(COPY_ROSTER, copyRosterSaga);
}
export function* addClockFlow() {
  yield takeEvery(ADD_CLOCK, addClockSaga);
}
export function* getPaidHoursFlow() {
  yield takeEvery(GET_PAID_HOURS, getPaidHoursSaga);
}
export function* getSettingsHistoryFlow() {
  yield takeEvery(GET_SETTINGS_HISTORY, getSettingsHistorySaga);
}
export function* claimShiftFlow() {
  yield takeEvery(CLAIM_SHIFT, claimShiftSaga);
}
export function* getLocSettingsFlow() {
  yield takeEvery(GET_LOC_SETTINGS, getLocSettingsSaga);
}
export function* saveLocSettingsFlow() {
  yield takeEvery(SAVE_LOC_SETTINGS, saveLocSettingsSaga);
}

export default function* RosterSaga() {
  yield all([
    fetchSettingsFlow(),
    saveSettingsFlow(),
    clockinFlow(),
    updateClockinFlow(),
    approveDropFlow(),
    rejectDropFlow(),
    updateRequestFlow(),
    approveSwapFlow(),
    rejectSwapFlow(),
    copyRosterFlow(),
    addClockFlow(),
    getPaidHoursFlow(),
    getSettingsHistoryFlow(),
    claimShiftFlow(),
    getLocSettingsFlow(),
    saveLocSettingsFlow(),
  ]);
}
